import { getCollectionDataById } from "../../helpers/index";
import runBatch from "../../utils/runBatch";

import createExportData from "./createExportData";

export default async function autoExport(firebase, { publisher, articlesWithArtifact }) {
	const pipelineIds = Object.keys(publisher?.exportPresets || {});

	if (!pipelineIds.length) {
		return;
	}

	const exportPipelines = await getCollectionDataById(
		firebase,
		firebase.firestore().collection("exportPresets"),
		pipelineIds,
	);

	if (!exportPipelines.length) {
		return;
	}

	return runBatch(firebase, (batch) => {
		for (const exportPipeline of exportPipelines) {
			for (const { article, artifact } of articlesWithArtifact) {
				const exportDoc = createExportData(firebase, {
					article,
					artifact,
					name: exportPipeline.name,
					pipeline: exportPipeline,
					publisher,
				});
				batch.set(exportDoc.ref, exportDoc);
			}
		}
	});
}
